<template>
<div><!-- div wrapper is required for router to properly function with model -->

<div class="ui small modal" id="processCartModal">
  <div class="header">
    Nemaksā degvielas piemaksu!
  </div>
  <div class="content">
    <div class="ui middle aligned grid">
      <div class="column">
        <div class="ui positive message">
          Izvēlies papildus kādu no simtiem pārtikas un saimniecības produktu, lai kopējais pirkuma grozs būtu vismaz 25 EUR.
        </div>
        <div class="ui segment">
          <div class="ui fluid green button" @click="closeCartModal">
            Turpināt iepirkties
          </div>
          <br />
          <div class="ui fluid custom_brown button" @click="processCart(false)">
            Noformēt grozu
          </div>
       </div>
      </div>
    </div>
  </div>
</div>

<div class="ui segments">

    <div class="ui segment">
        <div class="ui breadcrumb">
            <router-link :to="{name:'home'}" class="section">Sākums</router-link>
            <span class="divider">/</span>
            <div class="active section">Pirkumu grozs</div>
        </div>
    </div>
    <cart-steps step="1"></cart-steps>
    <div v-if="itemsInCart>0" class="ui attached segment" v-bind:class="{ loading: storeStatus.loading, loading: showLoading }">

        <div class="ui form">
            <!-- goods row -->
            <div class="ui divided items">
                <div v-for="item in items" class="item">
                    <div class="ui tiny image"   @click="$router.push('/good/'+item.link)" style="cursor:pointer">
                      <img  v-if="item.images[0]" :src="item.images[0].url" />
                      <img  v-else :src="'https://res.cloudinary.com/mwsuite/image/upload/f_auto,w_170,h_250,c_lfill/product/'+item.good_id+'.jpg'" />
                    </div>
                    <div class="content">

                        <router-link :to="'/good/'+item.link"  class="header">{{item.name}}</router-link>
                        <div class="meta">
                            <span v-if="item.has_promo_discount" class="cinema">Cena <span style="text-decoration: line-through;">{{(item.price_without_discount_vat).toFixed(2)}}</span><span style="color: #21BA45;">{{item.price_vat}}</span> &euro; gab.<span v-if="item.bail > 0">, Drošības nauda {{item.bail}} &euro;</span></span>
                            <span v-else class="cinema">Cena {{item.price_vat}} &euro; gab.<span v-if="item.bail>0">, Drošības nauda {{item.bail}} &euro;</span></span>
                        </div>
                        <div class="description">
                            <p>{{item.description}}</p>
                        </div>
                        <div class="extra">

                            <div class="ui grid">
                                <div class="fourteen wide column">
                                    <div class="ui right floated">
                                        <div class="ui left floated inline fields">
                                            <label style="width:85px; text-align:right">Pasūtīšu: &nbsp; x</label>
                                            <div class="field">
                                                <input type="text" placeholder="skaits" @input="showLoading = true; updateCartItemOrder(item);" v-model="item.order" :value="item.order" style="width:70px" number>
                                            </div>
                                        </div>
                                        <div v-if="item.isrentable == 1" class="ui left floated inline fields">
                                            <label style="width:85px; text-align:right">Atgriezīšu: &nbsp; x</label>
                                            <div class="field">
                                                <input type="text" placeholder="skaits" @input="showLoading = true; updateCartItemReturn(item);" v-model="item.return" :value="item.return" style="width:70px" number>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="two wide column">
                                    <button v-on:click="removeItem(item)" class="ui right floated grey icon button">
                                        <i class="right trash icon"></i>
                                    </button>
                                </div>
                            </div>

                            <div v-for="badge in item.badges" class="ui label" :style="{ backgroundColor: '#'+badge.color, color: '#210404'}">{{badge.label}}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="ui container">
                <button @click="$router.push({name: 'goods'})" class="ui right floated custom_brown button">Pievienot citus produktus</button>
                <div class="ui clearing hidden divider"></div>
            </div>
            
            <div class="ui container" style="display: flex; justify-content: flex-end; align-items: center;">
                <div class="ui right floated" style="display: flex; justify-content: flex-end; align-items: center;	gap: 5px; flex-wrap: wrap; margin-bottom: 0;">
                    <label>Atlaides kods:</label>
                    <input type="text" placeholder="Kods" v-model="cart.details.active_promo_code" :value="cart.details.active_promo_code" style="width: 200px;" />
                    <button @click="showLoading = true; activatePromoCode(cart.details.active_promo_code);" class="ui custom_brown button" style="margin: 0;">Aktivizēt</button>
                </div>
            </div>
            <div id="promo_response" class="ui" style="text-align: right; font-weight: bold; display: none;">Test</div>

        </div>
    </div>
    <div v-if="showDateAndAddress && itemsInCart>0 && cart.id && !nextAutoshipDelivery" class="ui attached segment">
      <div class="ui icon message">
          <img class="ui image small" src="../assets/autoship_logo.png" />
          <div class="content">
              <!-- show starting from 1 EUR -->
              <div class="header" v-if="cart.details.savings>=1">
                  Vēlies ietaupīt {{cart.details.savings}} &euro; par šo pasūtījumu?
              </div>
              <div class="header" v-else>
                Vēlies ietaupīt laiku un naudu?
              </div>
              <p>Izveido regulāru AutoShip pasūtījumu un iegūsti atlaidi katram pasūtījumam.</p>
              <button  @click="convertCartToAutoship" class="ui  green button"><i class="icon plus"></i>Pievienot AutoShip</button>
          </div>
      </div>
    </div>
    <div v-if="showDateAndAddress && itemsInCart>0 && cart.id && nextAutoshipDelivery && nextAutoshipDelivery.status == 3" class="ui attached segment">
      <div class="ui icon message">
          <img class="ui image small" src="../assets/autoship_logo.png" />
          <div class="content">

              <div class="header">
                Uzmanību!
              </div>
              <p>Jums ir aktīvs Autoship pasūtijums, kuru plānots piegādāt {{nextAutoshipDelivery.delivery_date}}
              <br>Vēlaties pievienot izvēlētās preces tuvākajām Autoship pasūtījumam?</p>
              <button @click="addGoodsToNearestOrder" class="ui custom_brown button"><i class="icon plus"></i>Pievienot tuvākajam AutoShip</button>
          </div>
      </div>
    </div>
    <div v-if="itemsInCart>0  && cart.id" class="ui secondary segment">

        <div class="ui two column grid">
            <div class="row">
                <div class="ui column form">
                    <div class="ui field delivery_type_container" v-if="showDateAndAddress">
                        <label>Piegādes adrese</label>
                        <select class="ui fluid dropdown" v-if="renderComponent" @change="showLoading = true; changeDeliveryAddressAndType($event.target.value, true);">
                            <option v-for="item in addressdeliverytype" :value="item.address.id + '|' + item.deliveryType.id" v-bind:selected="(item.address.id == cart.address_id && item.deliveryType.id == cart.delivery_type_id) ? true:false">{{item.deliveryType.title}}&nbsp;-&nbsp;<span v-if="item.address.id != 0">{{item.address.street}}<span v-if="item.address.house_no !=''">&nbsp;</span>{{item.address.house_no}}<span v-if="item.address.flat_no !=''">,&nbsp;</span>{{item.address.flat_no}}<span v-if="item.address.city_label !=''">,&nbsp;</span>{{item.address.city_label}}&nbsp;-&nbsp;</span>{{item.deliveryType.price}}&euro;</option>
                        </select>
                        <!--select class="ui fluid dropdown" @change="changeDeliveryAddress($event.target.value)">
                            <option v-for="item in address" :value="item.id" v-bind:selected="item.id == cart.address_id ? true:false">{{item.street}}<span v-if="item.house_no !=''">&nbsp;</span>{{item.house_no}}<span v-if="item.flat_no !=''">,&nbsp;</span>{{item.flat_no}}<span v-if="item.city_label !=''">,&nbsp;</span>{{item.city_label}}</option>
                        </select-->
                    </div>
                    
                    <div class="ui field third-party-courier-warning" onclick="this.style.opacity = '0'; this.style.height = '0'; return false;" style="opacity: 0; height: 0; overflow: hidden; color: red; padding: 10px; text-align: justify; line-height: 1.5em; user-select: none; cursor: pointer; transition: 0.5s; box-shadow: rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px; border-radius: 5px;">
                        Lūdzu, ņemiet vērā, ka:<br />
                        1. Visu atbildību par preču piegādi un termiņiem uzņemas Jūsu izvēlētā kurjerfirma.<br />
                        2. Netiek nodrošināts temperatūras režīms, tādēļ lūdzu rūpīgi izvērtējiet vai šāds piegādes veids ir piemērots Jūsu groza saturam.<br />
                        3. Zemāk tiek norādīts nevis piegādes datums, bet datums, kad mēs nododam jūsu pasūtījumu kurjerfirmai. Tātad piegāde visdrīzāk būs 2-3 darba dienu laikā.<br />
                        4. Ja groza vērtība pārsniegs 50.00 EUR, piegāde būs bezmaksas.
                    </div>

                    <div class="ui field">
                        <label>Komentāri</label>
                        <textarea id="notes" rows="4" placeholder="" :value="cart.notes" @change="updateActiveCart('notes', $event.target.value);"></textarea>
                    </div>
                </div>

                <div class="column">
                    <div class="ui column form">
                        <div class="ui field calendar calendar_container" id="start_date" v-if="showDateAndAddress" style="display: none;">
                            <label>Piegādes datums</label>
                            <div class="ui input left icon">
                                <i class="calendar icon"></i>
                                <input type="text" placeholder="Norādit datumu no" :value="cart.delivery_date">
                            </div>
                        </div>
                        
                        <div v-if="renderComponent" v-for="item in parcelmachines" :id="'parcel_machines_' + item.deliveryType.id" class="ui field parcel_machine_container" style="display: none;">
                            <label>Pakomāts</label>
                            <select class="ui fluid dropdown" @change="showLoading = true; changeParcelMachine($event.target.value);">
                                <option v-for="m in item.deliveryType.parcel_machine_locations" :value="m">{{m}}</option>
                            </select>
                        </div>
                    </div>

                    <div style="float:right;">
                        <div class="ui list" style="text-align:right; margin-top:30px">
                            <div class="item" v-if="cart.details.water_goods_price_vat>0">Pamatpreces: {{cart.details.water_goods_price_vat}} &euro;</div>
                            <div class="item" v-if="cart.details.services_price_vat>0">Pakalpojums: {{cart.details.services_price_vat}} &euro;</div>
                            <div class="item" v-if="cart.details.no_water_goods_price_vat>0">Citas preces: {{cart.details.no_water_goods_price_vat}} &euro;</div>
                            <div class="item" v-if="cart.details.bail != 0" style="color:#E12F2E"><span id="bail" data-content="Turpiniet, ievadot piegādes datumu un pārbaudiet veikto pasūtījumu. Ņemiet vērā, ka par katru lietošanā esošo pudeli jāmaksā drošības nauda. Drošības nauda tiks atgriezta pēc tukšo pudeļu atdošanas">Drošības nauda: {{cart.details.bail}} &euro;</span></div>
                            <div class="item" v-if="cart.details.deposit_amount != 0"><span id="deposit">Depozīts: {{cart.details.deposit_amount}} &euro;</span></div>
                            <div class="item" v-if="cart.details.final_discount_vat != 0" style="color:#21BA45"><span>Atlaide: {{cart.details.final_discount_vat}} &euro;</span></div>
                            <div class="item" v-if="(cart.details.extra_delivery != 0) && (cart.details.water_goods_price_vat > 0)" style="color:#E12F2E"><span id="delivery" data-html="Degvielas piemaksa netiks pievienota, ja pasūtīsiet produktus par vismaz 25 EUR."><i class="info circle icon" data-html="Degvielas piemaksa netiks pievienota, ja pasūtīsiet produktus par vismaz 25 EUR."></i>Mainīgā degvielas piemaksa: {{cart.details.extra_delivery}} &euro;</span></div>
                            <div class="item" v-else-if="(cart.details.extra_delivery != 0)" style="color:#E12F2E"><span id="delivery" data-html="Piegādes maksa netiks pievienota, ja pasūtīsiet preces vismaz 25 EUR vērtībā. Ja pasūtiet specifiskus smagus produktus (piem. malka, granulas), tad tiek piemērota papildus piegādes maksa par gab.">Piegāde: {{cart.details.extra_delivery}} &euro;</span></div>
                            <div class="item"><b>Kopsumma: {{(cart.details.total_price_with_bail_and_vat - cart.details.final_discount_vat).toFixed(2)}} &euro;</b></div>
              <div class="item" v-if="cart.details.bonus>0" style="color:#21BA45"><span id="bonus_cart" data-content="Par katru Memory Water 18,9l pasūtījumu jūs saņemat 2% bio un citu veselīgu produktu iegādei">Bonuss: + {{cart.details.bonus}} &euro; </span></div>
              <div class="item">&nbsp;</div>
              <div class="item" v-if="cart.details.bail_to_refund>0" style="color:#21BA45"><span id="bail_to_refund" data-content="Pēc pasūtījuma piegādes jums tiks atgriezta pārmaksātā Drošības nauda">Drošības naudas atmaksa: + {{cart.details.bail_to_refund}} &euro; </span></div>

            </div>
          </div>
        </div>
      </div>
      <div class="row">
          <div class="column"></div>
        <div class="column">

          <div class="ui right floated custom_brown animated button" :class="{ disabled: ((cart.delivery_date == '' && showDateAndAddress) || showLoading || storeStatus.loading), loading: showLoading || storeStatus.loading }" tabindex="0" @click="processCart(true)">
            <div class="visible content">Pasūtīt</div>
            <div class="hidden content">
              <i class="right arrow icon"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
      <div class="ui clearing hidden divider"></div>
  </div>
  <div v-if="itemsInCart==0 || !cart.id" class="ui attached segment">

    <!-- show in case payment status is not yet confirmed -->
    <div class="ui warning icon message">
      <i class="info circle icon"></i>
      <div class="content">
        <div class="header">
          Pirkumu grozs ir tukšs!
        </div>
        <p>Pievieno vismaz vienu <router-link :to="{name:'goods'}">preci</router-link> savam pirkumu grozam</p>
    </div>
  </div>
  </div>
</div>

</div>
</template>

<script>

import CartSteps from './CartSteps'

export default {
    components: {
        CartSteps
    },
    data() {
        return {
            showLoading: false,
            renderComponent: true
        }
    },
    computed: {
            user() {
                    return this.$store.state.userStore.user
                },
            storeStatus() {
                return this.$store.state.cartStore.status
            },
            items() {
                return this.$store.state.cartStore.items
            },
            cart() {
                return this.$store.state.cartStore.activeCart
            },
            itemsInCart() {
                return this.$store.state.cartStore.items.length;

            },
            address() {
                return this.$store.state.addressStore.items
            },
            addressdeliverytype() {
                return this.$store.state.addressStore.aditems
            },
            parcelmachines() {
                return this.addressdeliverytype.filter(function(t) {
                    return (t.deliveryType.is_courier_service == 0);
                });
            },
            autoshiplist() {
                return this.$store.state.autoShipStore.list;
            },

            nextAutoshipDelivery(){
                //copy object and find selected address
                var listObject = JSON.parse(JSON.stringify(this.$store.state.autoShipStore.list));

                if(this.cart && this.autoshiplist) {
                  var addressId = this.cart.address_id;
                  var index = listObject.findIndex(o => o.address_id == addressId && o.status == 1);

                  if (index >= 0) {
                      return (this.autoshiplist[index].next_order) ? this.autoshiplist[index].next_order : false
                  }
                  else return false
                }
                else return false;
            },
            //check if we should or should not show date/address
            showDateAndAddress(){
              if(this.cart && this.cart.details && this.cart.details.water_goods_price_vat == 0 && this.cart.details.no_water_goods_price_vat == 0 && this.cart.details.services_price_vat > 0){
                return false;
              }
              else return true;
            }
    },
    
    activated: function() {
        //reset data
        this.showLoading = true;
        //preload data
        this.$store.dispatch('loadActiveCart').then((response) => {
            this.$store.dispatch('loadCartItems', this.cart.id);
            //this.$store.dispatch('loadAddress').then(() => {
                this.$store.dispatch('loadAddressDeliveryType', this.cart.id).then((response) => {
                    this.refreshDeliveryDetails(response);
                    this.showLoading = false;
                    //this.forceRerender();
                });
            //});
            this.enablePopups();
        }).catch((error) => {
            console.error('Cart was not loaded');
            this.showLoading = false;
        });

        this.$store.dispatch('loadAutoship');
    },

    watch: {
        "cart": function() {
            this.enablePopups();
        }
    },

    methods: {
        forceRerender() {
            this.renderComponent = false;
            this.$nextTick(() => {
                this.renderComponent = true;
            });
        },

        enablePopups: _.debounce(function() {
            $('#bail').popup();
            $('#delivery').popup();
            $('#bonus_cart').popup();
            $('#bail_to_refund').popup();
        }, 500),

        removeItem: function(item) {
            this.showLoading = true;
            this.$store.dispatch('removeCartItem', item).then((response) => {
                this.$store.dispatch('loadActiveCart', this.cart.id).then((response) => {
                    this.$store.dispatch('loadAddressDeliveryType', this.cart.id).then((response) => {
                        this.refreshDeliveryDetails(response);
                        this.showLoading = false;
                        //this.forceRerender();
                    });
                });
            }).catch((error) => {
                console.error('Cart was not loaded');
                this.showLoading = false;
            });
        },

        updateCartItemReturn: function(item) {
            this.showLoading = true;
            if (!item.return) {
              this.showLoading = false;
              return;
            } else {
              var updatedItem = JSON.parse(JSON.stringify(item)); //copy object
              updatedItem.return = item.return;
              this.$store.dispatch('addCartItem', [this.cart.id, updatedItem]).then((response) => {
                  this.$store.dispatch('loadActiveCart', this.cart.id);
                  this.showLoading = false;
              }).catch((error) => {
                  console.error('Cart was not loaded');
                  this.showLoading = false;
              });
            }
        },
        
        updateCartItemOrder: function(item) {
          this.showLoading = true;
          //if (item.order == 0) this.removeItem(item);
          if (!item.order) {
            this.showLoading = false;
            return;
          } else {
            var updatedItem = JSON.parse(JSON.stringify(item)); //copy object
            updatedItem.order = item.order;
            this.$store.dispatch('addCartItem', [this.cart.id, updatedItem]).then((response) => {
                this.$store.dispatch('loadActiveCart', this.cart.id).then((response) => {
                    this.$store.dispatch('loadAddressDeliveryType', this.cart.id).then((response) => {
                        this.refreshDeliveryDetails(response);
                        this.showLoading = false;
                        //this.forceRerender();
                    });
                });
            }).catch((error) => {
                console.error('Cart was not loaded');
                this.showLoading = false;
            });
          }
        },
        
        activatePromoCode: function() {
          this.showLoading = true;
          this.$store.dispatch('activatePromoCode', [this.cart.details.active_promo_code]).then((response) => {
              var resultText = document.querySelector('#promo_response');
              if (resultText) {
                  resultText.innerHTML = response.data.message;
                  resultText.style.color = (response.data.activated) ? '#21BA45' : '#E12F2E';
                  resultText.style.display = 'block';
              }
              this.$store.dispatch('loadActiveCart', this.cart.id).then((response) => {
			      this.$store.dispatch('loadCartItems', this.cart.id);
                  this.showLoading = false;
				  //this.forceRerender();
              });
          }).catch((error) => {
              console.error('Promo code was not activated');
              this.showLoading = false;
          });
        },

        isDateDisabled(date, mode, addressId) {
            if (date) {
                var address = this.getSelectedAddress(addressId);
                if (!address) return true;

                //check if date is in the past + 1
                if(date <= new Date()){
                  return true;
                }
                
                //check if there is restricted dates for address. If dates are in past then user will not be able to select any date!
                else if (address.allowed_dates != "") {
                    //add ";" in front of date string and when searching for ;d-m-yyyy. This is required
                    //to ensure that 5-12-2016 would not match with 15-12-2016
                    var dmy = ";" + date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
                    address.allowed_dates = ";" + address.allowed_dates;
                    if (address.allowed_dates && address.allowed_dates.indexOf(dmy) > -1) { //dates are passed in string format d-mm-yyyy,d-mm-yyyy
                        //return false;
                        
                        //days config override
                        var dm = ';' + date.getDate() + "-" + (date.getMonth() + 1) + ';';
                        if (address.forbidden_working_days != "" && address.forbidden_working_days.indexOf(dm) > -1) { //dates are passed in string format d-mm-yyyy,d-mm-yyyy
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        //return true;
                        
                        //days config override
                        var dm = ';' + date.getDate() + "-" + (date.getMonth() + 1) + ';';
                        if (date.getDay() == 0) {
                            if (address.allowed_weekends != "" && address.allowed_weekends.indexOf(dm) > -1) { //dates are passed in string format d-mm-yyyy,d-mm-yyyy
                                return false;
                            } else {
                                return true;
                            }
                        }
                    }
                } else { //check if weekend is allowed or working day disabled
                    var dm = ';' + date.getDate() + "-" + (date.getMonth() + 1) + ';';
                    // if day is Sunday then check if its allowed using allowed_weekends attribute
                    if (date.getDay() == 0) {
                        if (address.allowed_weekends != "" && address.allowed_weekends.indexOf(dm) > -1) { //dates are passed in string format d-mm-yyyy,d-mm-yyyy
                            return false;
                        } else {
                            return true;
                        }
                    } else { //if day is working day or Sat.day
                        //then check if its restricted
                        if (address.forbidden_working_days != "" && address.forbidden_working_days.indexOf(dm) > -1) { //dates are passed in string format d-mm-yyyy,d-mm-yyyy
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            }

            //in all other cases disable date
            return true;
        },
        
        getSelectedAddress(addressId) {
            if (addressId == 0) return false;
            
            //copy object and find selected address
            var addressObject = JSON.parse(JSON.stringify(this.address));

            var index = addressObject.findIndex(o => o.id == addressId);
            if (index >= 0) {
                return addressObject[index]
            }
             else {
              console.error('Returning first available address');
              return addressObject[0]
            }
        },
        
        //small debounce due to render
        activateCalendar: _.debounce(function(addressId) {
            //get selected address, used later
            var address = this.getSelectedAddress(addressId);

            //check if next date is not disabled, if it is then try to get next available date
            //first convert yyyy-mm-dd to date
            var st = (this.cart.delivery_date) ? this.cart.delivery_date : '';
            var pattern = /(\d{2})\-(\d{2})\-(\d{4})/;
            var date = new Date(st.replace(pattern, '$1-$2-$3'));
            //check if not disabled
            if (this.cart.delivery_date != "" && this.cart.delivery_date != null && !this.isDateDisabled(date, '', addressId)) {
                var nextDate = date;
                var nextDateOk = true;

            }
            //if disabled then pick up next available date
            else {


                var nextDate = new Date();
                var nextDateOk = false;
                var i;

                if (address && address.allowed_dates != "") {

                    //check if any of next 90 days are within allowed dates
                    for (i = 1; i < 90; i++) { //start with tomorrow

                        //increment
                        nextDate.setDate(nextDate.getDate() + 1);
                        var dmy = ";" + nextDate.getDate() + "-" + (nextDate.getMonth() + 1) + "-" + nextDate.getFullYear();
                        address.allowed_dates = ";" + address.allowed_dates;
                        //check if its within allowed_dates dates

                        if (address.allowed_dates.indexOf(dmy) > -1 && !this.isDateDisabled(nextDate, '', addressId)) {
                            nextDateOk = true;
                            break;
                        }
                    }
                }
                else {

                    for (i = 1; i < 90; i++) { //start with tomorrow

                        nextDate.setDate(nextDate.getDate() + 1);

                        var dm = ';' + nextDate.getDate() + "-" + (nextDate.getMonth() + 1) + ';'



                        //if weekend then check if its allowed
                        //only sundays
                        if (nextDate.getDay() == 0) {



                            if (address && address.allowed_weekends != "" && address.allowed_weekends.indexOf(dm) > -1) {

                                nextDateOk = true;
                                break;
                            }
                        }
                        //if working day then check that its not forbidden
                        else if (address && address.forbidden_working_days != "" && address.forbidden_working_days.indexOf(dm) == -1) {

                            nextDateOk = true;
                            break;
                        }


                    }
                }
            }

            //update date in cart and calendar

            var day = nextDate.getDate();
            if (day < 10) {
                day = '0' + day;
            }
            var month = nextDate.getMonth(); //settings.text.months[];
            month++
            if (month < 10) {
                month = '0' + month;
            }
            var year = nextDate.getFullYear();
            var ymd = year + '-' + month + '-' + day;

            var deliveryDate = (nextDateOk) ? ymd : '';

            var updatedCart = JSON.parse(JSON.stringify(this.cart));

            if (address) {
              updatedCart.delivery_date = deliveryDate;
              updatedCart.address_id = address.id;
              //if there is no data then set it on cart object to prevent user from proceeding
              if (deliveryDate == '') this.$store.commit('SET_CART', updatedCart);
              else this.$store.dispatch('updateActiveCart', updatedCart);
            }

            var today = new Date();

            var self = this;

            $('#start_date').calendar({
                type: 'date',
                firstDayOfWeek: 1,
                touchReadonly: true,
                maxDate: new Date(today.getFullYear(), today.getMonth() + 3, today.getDate() + 1),
                minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1),
                /*
                //removed as it requires reinitiate calendar after store is reloaded
                text: {
                     days: ['Sv.', 'P', 'O', 'T', 'C', 'P', 'S'],
                     months: ['Janvāris', 'Februāris', 'Marts', 'Aprīlis', 'Maijs', 'Jūnijs', 'Jūlijs', 'Augusts', 'Septembris', 'Oktobris', 'Novembris', 'Decembris'],
                   },
                  */
                formatter: {
                    date: function(date, settings) {

                        if (!date) return '';
                        var day = date.getDate();
                        if (day < 10) {
                            day = '0' + day;
                        }
                        var month = date.getMonth(); //settings.text.months[];
                        month++
                        if (month < 10) {
                            month = '0' + month;
                        }
                        var year = date.getFullYear();
                        return year + '-' + month + '-' + day;
                    }
                },
                // is the given date disabled?
                isDisabled: function(date, mode) {
                    return self.isDateDisabled(date, mode, addressId);
                    if (!date) return true;

                },
                onChange: function(date, text) {

                    var day = date.getDate();
                    if (day < 10) {
                        day = '0' + day;
                    }
                    var month = date.getMonth(); //settings.text.months[];
                    month++
                    if (month < 10) {
                        month = '0' + month;
                    }
                    var year = date.getFullYear();
                    var ymd = year + '-' + month + '-' + day;

                    var updatedCart = JSON.parse(JSON.stringify(self.cart));

                    updatedCart.delivery_date = ymd;
                    updatedCart.address_id = address.id;

                    self.$store.dispatch('updateActiveCart', updatedCart);

                },
            });
            //mutate date, but dont commit to server
            
            this.showLoading = false;
        }, 700),

        changeDeliveryAddress: function(addressId) {
            //pass selected address to calendar so that it can recalculate which days to show and which no
            this.activateCalendar(addressId);
        },
        
        changeDeliveryAddressAndType: _.debounce(function(data, updateCart) {
            this.showLoading = true;
            var array = data.split('|');
            var addressID = 0;
            var deliveryTypeID = 0;
            if (array.length >= 2) {
                addressID = parseInt(array[0], 10);
                deliveryTypeID = parseInt(array[1], 10);
                deliveryTypeID = (isNaN(deliveryTypeID)) ? 0 : deliveryTypeID;
                
                var deliveryTypeElements = document.querySelectorAll('.parcel_machine_container');
                deliveryTypeElements.forEach(t => {
                    t.style.display = 'none';
                });
                var parcelMachines = document.querySelector('#parcel_machines_' + deliveryTypeID);
                if (parcelMachines) parcelMachines.style.display = 'initial';
                
                if (deliveryTypeID == 1) { // in house courier delivery
                    var warningBlock = document.querySelector('.third-party-courier-warning');
                    if (warningBlock) {
                        warningBlock.style.opacity = '0';
                        warningBlock.style.height = '0';
                    }
                } else {
                    var warningBlock = document.querySelector('.third-party-courier-warning');
                    if (warningBlock) {
                        warningBlock.style.opacity = '1';
                        warningBlock.style.height = '170px';
                    }
                }
                
                if (addressID != 0 && !isNaN(addressID)) {
                    var calendarContainer = document.querySelector('.calendar_container');
                    if (calendarContainer) calendarContainer.style.display = 'initial';
                    if (updateCart) {
                        this.cart.delivery_type_id = deliveryTypeID;
                        this.cart.parcel_machine_location = '';
                        this.activateCalendar(addressID);
                    } else {
                        this.showLoading = false;
                    }
                } else {
                    var calendarContainer = document.querySelector('.calendar_container');
                    if (calendarContainer) calendarContainer.style.display = 'none';
                    if (updateCart) {
                        var updatedCart = JSON.parse(JSON.stringify(this.cart));
                        updatedCart.address_id = 0;
                        updatedCart.delivery_type_id = deliveryTypeID;
                        var parcelMachineLocations = document.querySelector('#parcel_machines_' + deliveryTypeID + ' > select');
                        if (parcelMachineLocations) updatedCart.parcel_machine_location = parcelMachineLocations.value;
                        this.$store.dispatch('updateActiveCart', updatedCart).then((response) => {
                            this.showLoading = false;
                        }).catch((error) => {
                            this.showLoading = false;
                        });
                    } else {
                        this.showLoading = false;
                    }
                }
            }
        }, 100),
        
        changeParcelMachine: function(parcelMachineLocation) {
            this.showLoading = true;
            var updatedCart = JSON.parse(JSON.stringify(this.cart));
            updatedCart.parcel_machine_location = parcelMachineLocation;
            this.$store.dispatch('updateActiveCart', updatedCart).then((response) => {
                this.showLoading = false;
            }).catch((error) => {
                this.showLoading = false;
            });
        },
        
        refreshDeliveryDetails: function(response) {
            if ((this.cart.address_id != response.address_id) || (this.cart.delivery_type_id != response.delivery_type_id)) {
                this.cart.address_id = response.address_id;
                this.cart.delivery_type_id = response.delivery_type_id;
                this.cart.details.extra_delivery = response.extra_delivery;
                
                var deliveryTypeSelect = document.querySelector('#delivery_type_container select');
                if (deliveryTypeSelect) deliveryTypeSelect.value = response.address_id + '|' + response.delivery_type_id;
            }
            this.cart.details.total_price_with_bail_and_vat = (parseFloat(this.cart.details.total_price_vat) + parseFloat(this.cart.details.extra_delivery) + parseFloat(this.cart.details.deposit_amount)).toFixed(2);
        
            var deliveryTypeElements = document.querySelectorAll('.parcel_machine_container');
            deliveryTypeElements.forEach(t => {
                t.style.display = 'none';
            });
            
            if (this.cart.delivery_type_id == 1) { // in house courier delivery
                var calendarContainer = document.querySelector('.calendar_container');
                if (calendarContainer) calendarContainer.style.display = 'initial';
                this.activateCalendar(this.cart.address_id);
                
                var warningBlock = document.querySelector('.third-party-courier-warning');
                if (warningBlock) {
                    warningBlock.style.opacity = '0';
                    warningBlock.style.height = '0';
                }
            } else {
                var parcelMachines = document.querySelector('#parcel_machines_' + this.cart.delivery_type_id);
                if (parcelMachines) {
                    var calendarContainer = document.querySelector('.calendar_container');
                    if (calendarContainer) calendarContainer.style.display = 'none';
                    parcelMachines.style.display = 'initial';
                } else {
                    var calendarContainer = document.querySelector('.calendar_container');
                    if (calendarContainer) calendarContainer.style.display = 'initial';
                    this.activateCalendar(this.cart.address_id);
                }
                
                var warningBlock = document.querySelector('.third-party-courier-warning');
                if (warningBlock) {
                    warningBlock.style.opacity = '1';
                    warningBlock.style.height = '170px';
                }
            }
        },
        
        closeCartModal: function() {
            $('#processCartModal').modal('hide all');
        },

        processCart: _.debounce(function(checkConfirmation) {
            this.showLoading = true;
            
            if (checkConfirmation && (this.cart.details.water_goods_price_vat > 0) && (this.cart.details.extra_delivery != 0)) {
                $('#processCartModal').modal({ blurring: true }).modal('setting', 'closable', false).modal('show');
                this.showLoading = false;
                return;
            } else {
                $('#processCartModal').modal('hide all');
            }
            
            var updatedCart = JSON.parse(JSON.stringify(this.cart)); //copy object
            
            //updatedCart.notes = $('#notes').val(); //using this aproach instead of sync note before its processed as its hard to ensure that store and server is in sync while user is clicking process cart
            var notes = document.querySelector('#notes');
            if (notes) updatedCart.notes = notes.value;

            var parcelMachineLocations = document.querySelector('#parcel_machines_' + this.cart.delivery_type_id + ' > select');
            if (parcelMachineLocations) updatedCart.parcel_machine_location = parcelMachineLocations.value;
            
            if (this.cart.address_id == 0) {
                var nextDate = new Date();
                var day = nextDate.getDate();
                if (day < 10) day = '0' + day;
                var month = nextDate.getMonth(); month++;
                if (month < 10) month = '0' + month;
                var year = nextDate.getFullYear();
                var ymd = year + '-' + month + '-' + day;
                updatedCart.delivery_date = ymd;
                if (this.cart.delivery_type_id == 0) {
                    var addressObject = JSON.parse(JSON.stringify(this.address));
                    updatedCart.address_id = addressObject[0].id;
                }
            }

            //info for fbook
            var ids = [];
            var numItems = 0

            for (var key in this.cart.items) {

              ids.push(this.cart.items[key].good_id)
              numItems = numItems + Number(this.cart.items[key].order)

            }

            fbq('track', 'InitiateCheckout', {
              value: this.cart.details.total_price_with_bail_and_vat,
              currency: 'EUR',
              content_ids:ids,
              num_items:numItems
            });

            this.$store.dispatch('updateActiveCart', updatedCart).then((response) => {
                this.$router.push({
                    name: 'cart-payment'
                });
            }).catch((error) => {
                console.error('Cart was not updated due to error: ' + error);
                this.showLoading = false;
            });
        }, 50),

        convertCartToAutoship(){
          //add autoship params to cart and go to edit page
          this.$store.dispatch('convertCartToAutoship', this.cart).then((response) => {
              this.$router.push({
                  name: 'autoship-edit',
                  params: {
                    id:response.data.cart.id
                  }

              });
          }).catch((error) => {
              console.error('Cart was not converted, error: ' + error);
              this.showLoading = false;
          });

        },

        addGoodsToNearestOrder(){
          this.$store.dispatch('addCartToNearestOrder', this.cart).then((response) => {
              //todo add feedback message that goods are added to order
              this.$router.push({
                  name: 'waiting-for-delivery'
              });
          }).catch((error) => {
              console.error('Cart was not converted, error: ' + error);
          });
        },

        //update order data to recalculate total amount
        updateActiveCart(field,value){
          var cart = JSON.parse(JSON.stringify(this.cart));
          cart[field] = value;
          this.$store.dispatch('updateActiveCart', cart);
        },
    }
}

</script>



// WEBPACK FOOTER //
// CartPage.vue?4701743a